import Vuex from 'vuex'
import Vue from 'vue'
import products from './modules/products'
import shoppingCart from './modules/shopping_cart'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        products,
        shoppingCart
    }
})